import { API_BASE_URL } from "../../../config";

export const defaultFormTemplate = {
      category_id: null,
      categoryName: null,
      cover_image:null,
      slug:null,
      is_parent:"yes",
      description:null,
      is_sys_category:null,
      modified_by:null,
      created_date:null,
      modified_date:null,
      cat_color: null,
      parent_id:null,
      status: 'active',
};
export const validationRules = {
  categoryName: { required: true, maxLength: 100 },
  description: { maxLength: 500},
  slug: { required: true,},
};
export const defaultColumns = [
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"category_id","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"categoryName","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
 
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"cat_color","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"is_sys_category","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentCategory":""},
];
export const columnLabels = {
  customer_id: 'Category ID',
  categoryName: 'Category Name',
  cat_color: 'Color',
  is_sys_category:"System Define Category",
  is_parent:"Is a Parent Category",
  parent_id:"Parent Category",
  };

export const  skipFields=['cover_image',];
export const  filterSkipFields=["cover_image","cat_color"];
export  const fieldOverrides = {
            description:{
              type:"textarea"
            },
            parent_id:{
                type: 'smartSelectInput',
                config:{label: '',type:'category',source: 'category',placeholder: 'Select Parent Category',allowAddNew: false,preload: true,cache: true,
                showRecent: false,
                customURL:`${API_BASE_URL}/categoryMasterList`,
                customParameters:{status:"active",getAll:"Y",is_parent:"yes",isSub:"N"},
                getLabel: (item) => `${item.categoryName}`,
                getValue: (item) => item.category_id,}
            },
            is_parent:{
              type: 'radio',
              label: 'Is Parent',
              options: [
                  { value: 'yes', label: 'Yes' },
                  { value: 'no', label: 'No' }
                ]
              },
            created_by: {
              type: 'smartSelectInput',
              config: {
                label: 'Created By',
                type: 'admin',
                source: 'admin',
                valueKey:'adminID',
                placeholder: 'Select Created By',
                check: 'name',
                getLabel: (item) => `${item.name}`,
                getValue: (item) => item.adminID,
                allowAddNew: false,preload: true,cache: true,showRecent: true,multi:false,
                list: 'name,adminID'
              }
            },
            status: {
              type: 'radio',
              label: 'Status',
              options: [
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'In Active' }
                ]
              },
          };
export const directSchemaTemplate = [
  { Field: 'category_id', Type: 'int' },
  { Field: 'is_parent', Type:  `enum(yes,no)` },
  { Field: 'categoryName', Type: 'varchar' },
  { Field: 'slug', Type: 'varchar' },
  { Field: 'is_sys_category', Type:  `enum(yes,no)` },
  { Field: 'parent_id', Type: 'smartSelectInput' },
  { Field: 'description', Type: 'varchar' },
  { Field: 'modified_by', Type: 'int' },
  { Field: 'created_by', Type: 'smartSelectInput' },
  { Field: 'created_date', Type: 'date' },
  { Field: 'modified_date', Type: 'date' },
  { Field: 'cat_color', Type: 'varchar' },
  { Field: 'status', Type: `enum(active,inactive)` },
  
];
export const layout = [
    {
      label: 'Basic Info',
      row: [
     { field: 'categoryName',colSize:'w-full mb-3 md:w-1/3' },
     { field: 'slug' ,colSize:'w-full mb-3 md:w-1/3'},
     { field: 'is_parent'},
      ]
    },
    {
      row: [
      {custom:'CatColorPicker',colSize:'w-full mb-3 md:w-2/3'},
       { field: 'parent_id',showWhen: {
          field: 'is_parent',
          value: 'no'
        } },
      ]
    },
    {
      row: [
       { field: 'description'},
      ]
    },
    {
      row: [
       { addcustomFieldBtn: true },{ customFieldsPlaceholder: true }
      ]
    },
  ];
  export const infoIcons = {
    is_parent: { show: true, text: 'A parent category is a main category that can have subcategories under it. If this is a parent category, you can later add other categories as subcategories under it.' },
    slug: { show: true, text: `A unique slug is automatically generated from the category name (e.g., 'Task Status' becomes 'task_status'). This ensures each category has a distinct identifier for system-wide reference.`},
    parent_id: { show: true, text: `Select the parent category to organize this category as a subcategory.`},
    
  };